( function () {
   
    'use strict';
  
    ( function ( $ ) {
        $('.header-mobile-menu .menu').hide();
        $('.header-mobile-menu .icon').click(function() {
          $(this).toggleClass('active');
          $('.header-mobile-menu .menu').slideToggle("fast");
        });
        
        
        // $(document).click(function() {
        //   $('.header-icon ul li.login-icon').removeClass('hover');
        // });

        jQuery("#search").keyup(function(){
          if (jQuery(this).val().length > 2) {
              let serchval = jQuery(this).val();
              jQuery.ajax({
                  type: "POST",
                  cache: false,
                  url: ssAjax.ajaxurl,
                  data: { nonce: ssAjax.nonce, serchval:serchval, action: 'getserchdata' },
                  dataType: 'html',
                  success: function (response) {
                  // console.warn(response);
                      // $("#loaders").fadeOut();
                      // $("#datapritn").html("");
                      // $("#datapritn").html(response);
                      jQuery('#datafetch').show('');
                      jQuery('.header-search-result').show('');
                      jQuery('#defult').fadeOut('');
                      jQuery('#datafetch').html( response );
                     
                  }
              });
          }
          else{
              jQuery('#datafetch').html('');
              jQuery('#datafetch').hide('');
              jQuery('#defult').fadeIn('');
              jQuery('.header-search-result').hide('');
              
          }
      } );
        
} )( jQuery );
} )();